import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanDeactivate, CanLoad, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthenticationService } from './auth.service';
import { Observable } from 'rxjs';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate  {
//   constructor(private authService: AuthService, private router: Router) {}

//   canActivate(): boolean {
//     return this.checkAuth();
//   }

//   canActivateChild(): boolean {
//     return this.checkAuth();
//   }

//   canDeactivate(component: ProudctRatingComponent): boolean {
//     if (component.hasUnsavedChanges()) {
//       return window.confirm('You have unsaved changes. Do you really want to leave?');
//     }
//     return true;
//   }

//   canLoad(): boolean {
//     return this.checkAuth();
//   }

//   private checkAuth(): boolean {
//     if (this.authService.isAuthenticatedUser()) {
//       return true;
//     } else {
//       // Redirect to the login page if the user is not authenticated
//       this.router.navigate(['auth/login']);
//       return false;
//     }
//   }
constructor(private authService: AuthenticationService, private router: Router, private storage: StorageService) { }
canActivate(
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    console.log(window.location.pathname);
    if (!this.storage.get("auth") && window.location.pathname == "/auth") {
    this.router.navigate(["auth"])
    }else if(!this.storage.get("auth")){
      this.router.navigate(["landing"])
    }
  return true;
} 

}